export const routePermissions = [
    {path: "^/users$", requiredPermission: "Read", permissionName: "userManagement"},
    {path: "^/users/permission$", requiredPermission: "Permission", permissionName: "userManagement"},
    {path: "^/variants$", requiredPermission: "Read", permissionName: "variantList"},
    {path: "^/products$", requiredPermission: "Read", permissionName: "productList"},
    {path: "^/channels$", requiredPermission: "Read", permissionName: "DGPanel"},
    {path: "^/pricing$", requiredPermission: "Read", permissionName: "pricingPanel"},
    {path: "^/report/reportlist/[a-z][0-9]$", requiredPermission: "Report", permissionName: "reportManagement"},
    {path: "^/pricingpackageconfirm/*$", requiredPermission: "Report", permissionName: "reportManagement"},
    {path: "^/report/create$", requiredPermission: "Add", permissionName: "reportManagement"},


]